import { CardContentDirective } from './card-content.directive';
import { CardDescriptionDirective } from './card-description.directive';
import { CardFooterDirective } from './card-footer.directive';
import { CardHeaderDirective } from './card-header.directive';
import { CardTitleDirective } from './card-title.directive';
import { CardDirective } from './card.directive';

export * from './card-content.directive';
export * from './card-description.directive';
export * from './card-footer.directive';
export * from './card-header.directive';
export * from './card-title.directive';
export * from './card.directive';

export const CardModule = [
  CardDirective,
  CardHeaderDirective,
  CardTitleDirective,
  CardDescriptionDirective,
  CardContentDirective,
  CardFooterDirective,
];
